var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',_vm._g(_vm._b({staticClass:"mt-0 mb-0",attrs:{"hide-details":"","id":_vm.$attrs.label?_vm.$helper.slugify(_vm.$attrs.label):null}},'v-checkbox',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }